import { TranslationKey } from './../../../../../types/translation/TranslationKey';

import { t } from '../../../../../types/translation/Translator';
import React from 'react';

import { testIds } from '../../../../../util/identifiers/identifiers.util';
import { AddIcon } from '../../../../icons/Add/AddIcon';
import { Button } from '../../Button/Button';
import { MenuItemProps, MenuItemTemplateProps } from '../MenuItem';

export function NewMenuItemTemplate(onClick: () => void, props?: MenuItemTemplateProps): MenuItemProps {
  return {
    testId: testIds.new,
    onClick: onClick,
    text: t(TranslationKey.newText).singular.label,
    icon: <AddIcon />,
  };
}

interface NewMenuItemProps extends MenuItemTemplateProps {
  onClick: () => void;
}

export default function NewMenuItem({ onClick, ...props }: NewMenuItemProps) {
  return <Button {...NewMenuItemTemplate(onClick, props)} />;
}
